import { atom } from 'jotai';

export const subdomainAtom = atom<string | undefined>(undefined);
